<script lang="ts" setup>
const { siteName } = useSite()

useHead({
  htmlAttrs: { 'data-scene': 'documents' },
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} | ${siteName.value}` : siteName.value
  },
})
</script>

<template>
  <div class="blueprint-document">
    <NuxtPage />
  </div>

  <ConfirmDialog />
  <DynamicDialog />
  <Toast />
</template>
